import React from 'react';

 const NotFound=()=> {
  return <div>
           <h1>Not Found <i class="far fa-frown-open"></i> </h1>
           <p className='lead'>The page you are looking for does not exist! </p>
  </div>;
}

export default NotFound;